import styled from 'styled-components';

export const StyledDivFaIcon = styled.div`
margin: 0 0.3em; 
i {
  pointer-events: none;
}
`;
